import React, { useState } from "react";
import "./navbar.css";
import logo from "../img/log.png";
import { NavLink } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
function Navbar() {
  const cartitem = useSelector((store) => store.cart);

  const navigate = useNavigate();

  function logoClick() {
    navigate("/");
  }
  return (
    <>
      <div className="navbar_outer">
        <div className="logodiv">
          <img
            src={logo}
            alt="Not found"
            onClick={logoClick}
            className="logo"
          />
        </div>
        <div className="navList">
          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/shop">Shop</NavLink>
            </li>
            <li className="res_m">
              <NavLink to="/about">About</NavLink>
            </li>
            <li className="res_m">
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
